import React, { useContext, useEffect, useRef, useState } from "react";
import HeadBar from "../headBar/HeadBar";
import styles from "./Login.module.css";
import Button from "../../material/button/Button";
import Input from "../../material/input/Input";
import PasswordInput from "../../material/passwordInput/PasswordInput";
import LoadingWithClose from "../../material/loadingWithClose/LoadingWithClose";
import { useNavigate } from "react-router-dom";
import { HashLoader } from "react-spinners";
import { QRCodeSVG } from "qrcode.react";
import * as oneIdApi from "../../../service/oneIdApi";
import * as userApi from "../../../service/userApi";
import * as pubilcApi from "../../../service/publicApi";
import moment from "moment";
import AdviceModal from "../adviceModal/AdviceModal";
import { CurrentUserContext } from "../../../App";
import { RedirectCode400 } from "../../RedirectCode400";
import { environment } from "../../../config.env";

const ENDPOINT_MOHPROMT = environment.mohpromt_url || "";
const ENDPOINT_MOHPROMT_CLIENT_ID = environment.mohpromt_client_id || "";
const REDIRECT_DOMAIN = environment.redirect_domain || "";

function Login() {
  const { userRole, setUserRole, setIsMessage } =
    useContext(CurrentUserContext);

  const [showAdvice, setShowAdvice] = useState(false);
  const [cid, setCid] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingOneId, setLoadingOneId] = useState(false);
  const [qrCodeData, setQrCodeData] = useState({
    device_id: "",
    auth_req_id: "",
  });
  const [authReqId, setAuthReqId] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [onesID, setOnesID] = useState("");
  const nav = useNavigate();

  const timeOutRefQrCode = useRef(null);
  const timeOutRefId = useRef(null);

  const [counter, setCounter] = useState(0);

  useEffect(() => {
    // console.log(userRole,
    // setUserRole, CurrentUserContext)

    return () => {
      resetTimeout();
    };
  }, []);

  const checkExpireToken = (expire) => {
    // console.log('expire')
    // console.log(expire)
    let diff = moment().diff(expire, "seconds");
    // console.log(diff)
    if (diff >= 0) {
      return false;
    } else {
      return true;
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCounter(counter + 1);
      if (counter >= 180) {
        setCounter(0);
        getQrCode();
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [counter]);

  useEffect(() => {
    resetTimeout();
    if (timeOutRefId.current) {
      clearTimeout(timeOutRefId.current);
    }

    getQrCode();
  }, []);

  useEffect(() => {
    if (qrCodeData.auth_req_id !== "") {
      //checkAuthQrCode()
    }
  }, [qrCodeData]);

  useEffect(() => {
    if (loadingOneId) {
      checkAuth();
    }
  }, [authReqId]);

  useEffect(() => {
    return () => {
      if (timeOutRefQrCode.current) {
        clearTimeout(timeOutRefQrCode.current);
      }
    };
  }, [timeOutRefQrCode]);

  useEffect(() => {
    if (userRole === null) {
    } else {
      const tokenExpireAuth = localStorage.getItem("expire_login_user");
      if (checkExpireToken(tokenExpireAuth)) {
        nav(RedirectCode400());
        if (!tokenExpireAuth) {
        } else {
          window.location.reload();
        }
        return;
      }
    }
  }, [userRole]);

  function resetTimeout() {
    if (timeOutRefQrCode.current) {
      clearTimeout(timeOutRefQrCode.current);
    }
  }

  const getQrCode = async () => {
    // if (timeOutRefQrCode.current) {
    //   clearTimeout(timeOutRefQrCode.current)
    // }
    resetTimeout();

    setLoading(true);
    let res = await oneIdApi.getQrCode();
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        // console.log(res['data'])
        setQrCodeData({
          device_id: res["data"]["device_id"],
          auth_req_id: res["data"]["auth_req_id"],
        });
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const authOnesId = async () => {
    setLoading(true);
    let res = await oneIdApi.auth(onesID);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setAuthReqId(res["data"]["auth_req_id"]);
        setLoadingOneId(true);
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const checkAuthQrCode = async () => {
    let res = await oneIdApi.checkAuthQrCode(qrCodeData.auth_req_id);
    if (res) {
      if (res["data"]["code"] === 400) {
        //รอการยืนยัน
        resetTimeout();
        timeOutRefQrCode.current = setTimeout(() => {
          checkAuthQrCode();
        }, 3000);
        return () => {
          resetTimeout();
        };
      } else if (res["data"]["code"] === 200) {
        let accessToken = res["data"]["access_token"];
        setLoadingOneId(false);
        loginOnesDid(accessToken);
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      resetTimeout();
      // console.log(res)
    }
  };

  const checkAuth = async () => {
    if (!loadingOneId) {
      return;
    }
    let res = await oneIdApi.checkAuth(authReqId);
    if (res) {
      if (res["data"]["code"] === 400) {
        if (timeOutRefId.current) {
          clearTimeout(timeOutRefId.current);
        }

        timeOutRefId.current = setTimeout(() => {
          checkAuth();
        }, 3000);
      } else if (res["data"]["code"] === 200) {
        let accessToken = res["data"]["access_token"];
        setLoadingOneId(false);
        loginOnesDid(accessToken);
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };
  const loginUserNameButton = async () => {
    if (!userName) {
      setIsMessage({ type: "warning", data: "กรุณากรอกชื่อผู้ใช้" });
      return;
    }
    if (!password) {
      setIsMessage({ type: "warning", data: "กรุณากรอกรหัสผ่าน" });
      return;
    }

    setLoading(true);
    let res = await userApi.login(userName, password);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        logedIn(res["data"]);
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };
  const loginOnesDid = async (accessToken) => {
    setLoading(true);
    let res = await userApi.loginOnesDiD(accessToken);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        logedIn(res["data"]);
      } else if (res["data"]["code"] === 404) {
        let data = res["data"]["ones_did_user_data"];
        nav("/register", {
          state: {
            type: "register_onesdid",
            pname: data["pname"],
            fname: data["fname"],
            lname: data["lname"],
            pid: data["pid"],
            onesDid: data["ones_did"],
            access_token: data["access_token"],
            yearOB: moment(data["birthday"], ["DD/MM/YYYY", "YYYY-MM-DD"]).format("YYYY"),
            monthOB: moment(data["birthday"], ["DD/MM/YYYY", "YYYY-MM-DD"]).format("MM"),
            dayOB: moment(data["birthday"], ["DD/MM/YYYY", "YYYY-MM-DD"]).format("DD"),
          },
        });
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };
  const logedIn = (data) => {
    // if (timeOutRefQrCode.current) {
    //   clearTimeout(timeOutRefQrCode.current)
    // }
    localStorage.setItem(
      "pg_access_token",
      data["user_data"]["auth"]["access_token"],
    );
    localStorage.setItem(
      "expire_login_user",
      data["user_data"]["auth"]["access_token_expire"],
    );
    localStorage.setItem("user", JSON.stringify(data["user_data"]));
    setUserRole(data["user_data"]);
    if (data.user_data.auth.role[0] === "MEDICAL_PERSONNEL") {
      nav("/doctor/guideline");
    } else if (data.user_data.auth.role[0] === "HOSPITAL_PERSONNEL") {
      nav("/");
    } else if (data.user_data.auth.role[0] === "LABORATORY_ADMIN") {
      nav("/inputdata");
    } else if (data.user_data.auth.role[0] === "LABORATORY_PERSONNEL") {
      nav("/inputdata");
    } else if (data.user_data.auth.role[0] === "PATIENT") {
      nav("/");
    } else if (data.user_data.auth.role[0] === "ADMIN") {
      nav("/admin");
    } else if (data.user_data.auth.role[0] === "EXECUTIVE") {
      nav("/manager/aggregateResult");
    } else if (data.user_data.auth.role[0] === "HOSPITAL") {
      nav("/hospital/setting");
    } else {
      console.log("ยังไม่ได้ทำfunction check role user");
    }
  };

  const suggestionButton = () => {
    setShowAdvice(true);
  };

  // const loginCidButton = () => {
  //   if (!cid) {
  //     setIsMessage('กรุณากรอก CID')
  //     return
  //   }
  // }

  const forgetPasswordButton = () => {
    // if (timeOutRefQrCode.current) {
    //   clearTimeout(timeOutRefQrCode.current)
    // }
    nav("/resetPassword");
  };

  const clickGetOauthUrl = async () => {
    setLoading(true);
    let res = await pubilcApi.getOauthUrl();
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        // console.log(res['data']['auth_url'])
        window.open(res["data"]["auth_url"], "_system");
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  return (
    <div className="global-page">
      <AdviceModal
        show={showAdvice}
        onClose={() => {
          setShowAdvice(false);
        }}
      />
      <LoadingWithClose
        loading={loadingOneId}
        text={"กรุณากด approve ที่แอป OnesID"}
        onClose={() => {
          setLoadingOneId(false);
          if (timeOutRefId.current) {
            clearTimeout(timeOutRefId.current);
          }
        }}
      />
      <HashLoader
        loading={loading}
        style={{ display: "flex", justifyContent: "center" }}
        color="#FF9768"
      />
      <div className={styles.content}>
        <div className={styles.leftContent}>
          {/* <div className={styles.card}>
            <div className={styles.titleCard}>เข้าใช้งานด้วยบัตรประชาชน</div>
            <Input placeholder="บัตรประจำตัวประชาชน (CID)" value={cid} setValue={setCid}></Input>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Button onClick={loginCidButton}>เข้าสู่ระบบ</Button>
            </div>
          </div> */}

          <div
            className={`${styles.card} ${styles.pointer}`}
            style={{
              display: "grid",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={() => {
              window.open(
                `${ENDPOINT_MOHPROMT}/oauth/redirect?client_id=${ENDPOINT_MOHPROMT_CLIENT_ID}&redirect_uri=${REDIRECT_DOMAIN}/loginMohPromt&response_type=code`,
                "_system",
              );
            }}
          >
            <img
              style={{ margin: "auto", width: "100%" }}
              src={require("../../../asset/icon/mooprom.svg").default}
            ></img>
            <div className={styles.text}>เข้าใช้งานด้วยหมอพร้อม DID</div>
          </div>

          <div
            className={`${styles.card} ${styles.pointer}`}
            style={{
              display: "grid",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={() => {
              clickGetOauthUrl();
            }}
          >
            <img
              style={{ margin: "auto", width: "100%" }}
              src={require("../../../asset/icon/thaiId.svg").default}
            ></img>
            <div className={styles.text}>เข้าใช้งานด้วย ThaiD</div>
          </div>
        </div>

        <div className={styles.lineCenter}></div>

        <div className={styles.rightContent}>
          <img
            style={{ width: "100%" }}
            src={require("../../../asset/image/logo.svg").default}
          ></img>
          <div className={styles.title} style={{ marginTop: 20 }}>
            สำหรับผู้ใช้งานที่มี username
          </div>

          <div className={styles.card}>
            <div className={styles.titleCard}>เข้าใช้งานด้วย username</div>
            <div className={styles.keyInput}>ชื่อผู้ใช้งาน</div>
            <Input
              disabledLabel={true}
              placeholder="ชื่อผู้ใช้งาน"
              value={userName}
              setValue={setUserName}
            ></Input>
            <div className={styles.keyInput}>รหัสผ่าน</div>
            <PasswordInput
              disabledLabel={true}
              onEnter={loginUserNameButton}
              placeholder="รหัสผ่าน"
              value={password}
              setValue={setPassword}
            ></PasswordInput>
            <div className={styles.forgetPasswordContainer}>
              <div
                className={styles.forgetPasswordButton}
                onClick={() => {
                  forgetPasswordButton();
                }}
              >
                ลืมรหัสผ่าน
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button disabled={loading} onClick={loginUserNameButton}>
                เข้าสู่ระบบ
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.suggestionContainer}>
        <img
          src={require("../../../asset/icon/suggestion-icon.svg").default}
        ></img>
        <div
          className={styles.text}
          onClick={() => {
            suggestionButton();
          }}
        >
          แนะนำการสมัครใช้งานและการเข้าสู่ระบบ
        </div>
      </div>
    </div>
  );
}

export default Login;
